module.exports = __webpack_public_path__ + "img/wxqr.f6bcbd90.png";